"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardComparisonContainerState_1 = require("./CardComparisonContainerState");
var styles = require("./CardComparisonContainer.css");
var CardComparisonContainer = /** @class */ (function (_super) {
    __extends(CardComparisonContainer, _super);
    function CardComparisonContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new CardComparisonContainerState_1.default();
        _this.goRight = _this.goRight.bind(_this);
        _this.goLeft = _this.goLeft.bind(_this);
        _this.reactChild = React.Children.toArray(_this.props.children)[0];
        _this.rowChildrenCount = React.Children.count(_this.reactChild.props.children) - 1;
        _this.titleRowIndex = 1;
        return _this;
    }
    CardComparisonContainer.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.cardComparisonContainer }, this.renderChildren()));
    };
    CardComparisonContainer.prototype.goLeft = function () {
        if (this.state.comparisonIndex > 0) {
            this.setState({ comparisonIndex: this.state.comparisonIndex - 1 });
        }
    };
    CardComparisonContainer.prototype.goRight = function () {
        if (this.state.comparisonIndex < this.rowChildrenCount - 1) {
            this.setState({ comparisonIndex: this.state.comparisonIndex + 1 });
        }
    };
    CardComparisonContainer.prototype.renderChildren = function () {
        var _this = this;
        // tslint:disable-next-line:no-any
        return React.Children.map(this.props.children, function (child, index) {
            var data = __assign({ comparisonIndex: _this.state.comparisonIndex, current: _this.rowChildrenCount, showArrows: false }, child.props.data);
            var events = __assign({}, child.props.events);
            if (index === _this.titleRowIndex) {
                events.goLeft = _this.state.comparisonIndex > 0 ? _this.goLeft : null;
                events.goRight = _this.state.comparisonIndex < (_this.rowChildrenCount - 1) ? _this.goRight : null;
                data.showArrows = events.goLeft !== null || events.goRight !== null;
            }
            return React.cloneElement(child, {
                data: data,
                events: events,
            });
        });
    };
    return CardComparisonContainer;
}(React.Component));
exports.default = CardComparisonContainer;
//# sourceMappingURL=CardComparisonContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/CardComparisonContainer.js
// module id = 1305
// module chunks = 8